export default {
  property: {
    address: '',
    landlord: '',
    tenant: '',
    inspectionDate: new Date().toISOString().split('T')[0]
  },
  engineer: {
    engineerName: '',
    electricalRegNumber: '',
    company: '',
    phone: ''
  },
  circuits: [
    {
      circuitType: '',
      location: '',
      rating: '',
      protectiveDevice: '',
      testResult: '',
      remedialAction: ''
    }
  ],
  certification: {
    nextInspectionDate: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    certificateNumber: `EIC${Date.now()}`,
    engineerSignature: '',
    additionalNotes: ''
  }
};